import React, { Suspense } from 'react';
import CircularProgress from '../../../components/CircularProgress';

const RateDetail = React.lazy(() => import('../components/RateDetail'));
function RateDetailView(props: any) {
  return (
    <Suspense fallback={<CircularProgress />}>
      <RateDetail {...props} />
    </Suspense>
  );
}

export default RateDetailView;
